var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 4.66667V10C5.33366 10.3536 5.47413 10.6928 5.72418 10.9428C5.97423 11.1929 6.31337 11.3333 6.66699 11.3333H10.667M5.33366 4.66667V3.33333C5.33366 2.97971 5.47413 2.64057 5.72418 2.39052C5.97423 2.14048 6.31337 2 6.66699 2H9.72433C9.90112 2.00004 10.0707 2.0703 10.1957 2.19533L13.1383 5.138C13.2634 5.263 13.3336 5.43254 13.3337 5.60933V10C13.3337 10.3536 13.1932 10.6928 12.9431 10.9428C12.6931 11.1929 12.3539 11.3333 12.0003 11.3333H10.667M5.33366 4.66667H4.00033C3.6467 4.66667 3.30756 4.80714 3.05752 5.05719C2.80747 5.30724 2.66699 5.64638 2.66699 6V12.6667C2.66699 13.0203 2.80747 13.3594 3.05752 13.6095C3.30756 13.8595 3.6467 14 4.00033 14H9.33366C9.68728 14 10.0264 13.8595 10.2765 13.6095C10.5265 13.3594 10.667 13.0203 10.667 12.6667V11.3333",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.4204a236b097c4ac88e9a72dd5d3e324.svg";
export { ForwardRef as ReactComponent };